import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../axiosInstance";

const BASE_URL = `${process.env.REACT_APP_LISTOGRAPHY_API_PREFIX}`;

export const fetchMeasurements = createAsyncThunk(
  "measurements/fetchMeasurements",
  async () => {
    const response = await axios.get(`${BASE_URL}/api/measurements`);
    return response.data;
  }
);

const measurementSlice = createSlice({
  name: "measurements",
  initialState: {
    measurements: [],
    isLoadingMeasurements: false,
    error: null,
  },
  reducers: {
    clearMeasurements: (state) => {
      state.measurements = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetch measurements
      .addCase(fetchMeasurements.pending, (state) => {
        state.isLoadingMeasurements = true;
        state.error = null;
      })
      .addCase(fetchMeasurements.fulfilled, (state, action) => {
        state.measurements = action.payload;
        state.isLoadingMeasurements = false;
      })
      .addCase(fetchMeasurements.rejected, (state, action) => {
        state.isLoadingMeasurements = false;
        state.error = action.error.message;
      });
  },
});

export const { clearMeasurements } = measurementSlice.actions;

export default measurementSlice.reducer;
